import {useEffect, useMemo, useState} from "react";
import {sub} from "date-fns";

import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {usePropertyEstimatedPriceRegionValidation} from "../../../property/hooks/usePropertyEstimatedPriceRegionValidation";
import {ApiFieldToEstimatePriceType, DEFAULT_API_FIELD_TO_ESTIMATE_PRICE} from "../../../property/utils/estimated_price_utils";
import {useGetPricesAvailableDateQuery} from "../api/get_prices_available_date";
import {IGetPropertyEstimatedPricesQuery, useGetPropertyEstimatedPricesQuery} from "../api/get_property_estimated_prices";

type Region = {id: number; type: number};

interface IProperty {
    offer: {
        region: Region;
    };
}

export const usePropertyEstimatedPrice = (property: IProperty | undefined) => {
    const [fetchPricesQuery, setFetchPricesQuery] = useState<IGetPropertyEstimatedPricesQuery | null>(null);
    const [apiFieldWithAvgPrice, setApiFieldWithAvgPrice] = useState<ApiFieldToEstimatePriceType>(DEFAULT_API_FIELD_TO_ESTIMATE_PRICE);
    const [ignoreFetch, setIgnoreFetch] = useState(false);

    const {validatePropertyEstimatedPriceRegion, isRegionValidating} = usePropertyEstimatedPriceRegionValidation(
        setFetchPricesQuery,
        setApiFieldWithAvgPrice,
        () => setIgnoreFetch(true)
    );

    const {data: availableDate, isLoading: isAvailableDateLoading} = useGetPricesAvailableDateQuery();

    const pricesQuery = useMemo<IGetPropertyEstimatedPricesQuery | null>(() => {
        if (!fetchPricesQuery || !availableDate?.date) {
            return null;
        }

        const endDate = new Date(availableDate.date);

        return {
            ...fetchPricesQuery,
            date_start: formatDate(sub(endDate, {months: 6}).toISOString(), dateTimeFormat.dashedDateFormat),
            date_end: formatDate(endDate.toISOString(), dateTimeFormat.dashedDateFormat)
        };
    }, [fetchPricesQuery, availableDate]);

    const {data: estimatedPriceData, isLoading: isPriceDataLoading} = useGetPropertyEstimatedPricesQuery(pricesQuery || {}, {
        skip: !pricesQuery
    });

    useEffect(() => {
        if (!property) {
            return;
        }

        validatePropertyEstimatedPriceRegion(property.offer.region);
    }, [property?.offer.region.id]);

    return {
        estimatedPriceData,
        apiFieldWithAvgPrice,
        isLoading: !ignoreFetch && (isPriceDataLoading || isRegionValidating || isPriceDataLoading || isAvailableDateLoading)
    };
};
import {useEffect, useMemo, useState} from "react";
import {sub} from "date-fns";

import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {usePropertyEstimatedPriceRegionValidation} from "../../../property/hooks/usePropertyEstimatedPriceRegionValidation";
import {ApiFieldToEstimatePriceType, DEFAULT_API_FIELD_TO_ESTIMATE_PRICE} from "../../../property/utils/estimated_price_utils";
import {useGetPricesAvailableDateQuery} from "../api/get_prices_available_date";
import {IGetPropertyEstimatedPricesQuery, useGetPropertyEstimatedPricesQuery} from "../api/get_property_estimated_prices";

type Region = {id: number; type: number};

interface IProperty {
    offer: {
        region: Region;
    };
}

export const usePropertyEstimatedPrice = (property: IProperty | undefined) => {
    const [fetchPricesQuery, setFetchPricesQuery] = useState<IGetPropertyEstimatedPricesQuery | null>(null);
    const [apiFieldWithAvgPrice, setApiFieldWithAvgPrice] = useState<ApiFieldToEstimatePriceType>(DEFAULT_API_FIELD_TO_ESTIMATE_PRICE);
    const [ignoreFetch, setIgnoreFetch] = useState(false);

    const {validatePropertyEstimatedPriceRegion, isRegionValidating} = usePropertyEstimatedPriceRegionValidation(
        setFetchPricesQuery,
        setApiFieldWithAvgPrice,
        () => setIgnoreFetch(true)
    );

    const {data: availableDate, isLoading: isAvailableDateLoading} = useGetPricesAvailableDateQuery();

    const pricesQuery = useMemo<IGetPropertyEstimatedPricesQuery | null>(() => {
        if (!fetchPricesQuery || !availableDate?.date) {
            return null;
        }

        const endDate = new Date(availableDate.date);

        return {
            ...fetchPricesQuery,
            date_start: formatDate(sub(endDate, {months: 6}).toISOString(), dateTimeFormat.dashedDateFormat),
            date_end: formatDate(endDate.toISOString(), dateTimeFormat.dashedDateFormat)
        };
    }, [fetchPricesQuery, availableDate]);

    const {data: estimatedPriceData, isLoading: isPriceDataLoading} = useGetPropertyEstimatedPricesQuery(pricesQuery || {}, {
        skip: !pricesQuery
    });

    useEffect(() => {
        if (!property) {
            return;
        }

        validatePropertyEstimatedPriceRegion(property.offer.region);
    }, [property?.offer.region.id]);

    return {
        estimatedPriceData,
        apiFieldWithAvgPrice,
        isLoading: !ignoreFetch && (isPriceDataLoading || isRegionValidating || isPriceDataLoading || isAvailableDateLoading)
    };
};
